/** Homepage guide article bodies — i18n keys vc.story.{id}.p1 … p5 */

export const GUIDE_STORY_IDS = ['s1', 's2', 's3', 's4', 's5', 's6'] as const
export type GuideStoryId = (typeof GUIDE_STORY_IDS)[number]

/** Newest / featured story on the marketplace home preview */
export const FEATURED_GUIDE_STORY_ID: GuideStoryId = GUIDE_STORY_IDS[0]

const PARAGRAPH_KEYS: Record<GuideStoryId, string[]> = {
  s1: ['vc.story.s1.p1', 'vc.story.s1.p2', 'vc.story.s1.p3', 'vc.story.s1.p4', 'vc.story.s1.p5'],
  s2: ['vc.story.s2.p1', 'vc.story.s2.p2', 'vc.story.s2.p3', 'vc.story.s2.p4', 'vc.story.s2.p5'],
  s3: ['vc.story.s3.p1', 'vc.story.s3.p2', 'vc.story.s3.p3', 'vc.story.s3.p4', 'vc.story.s3.p5'],
  s4: ['vc.story.s4.p1', 'vc.story.s4.p2', 'vc.story.s4.p3', 'vc.story.s4.p4', 'vc.story.s4.p5'],
  s5: ['vc.story.s5.p1', 'vc.story.s5.p2', 'vc.story.s5.p3', 'vc.story.s5.p4', 'vc.story.s5.p5'],
  s6: ['vc.story.s6.p1', 'vc.story.s6.p2', 'vc.story.s6.p3', 'vc.story.s6.p4', 'vc.story.s6.p5'],
}

export function guideParagraphKeys(storyId: GuideStoryId): string[] {
  return PARAGRAPH_KEYS[storyId] ?? []
}
